import AnnotationsTextSelectionMenu from "./AnnotationsTextSelectionMenu";

export default AnnotationsTextSelectionMenu;
